<template>
    <div>
        <loader v-if="pageLoader"></loader>
        <alert-notification v-if="notification_msg != ''"/>
        <form action="" method="post" enctype="multipart/form-data" id="addressForm" v-on:submit.prevent="submitNow()" v-if="trans_id == '' && !congModule">
            <div class="SupportBlockCenter mb-3">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <input placeholder=" " class="form-control form-control" v-model="address1" name="address1"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('address1') }" ref="address1Input" >
                            <label for="username" class="labeltext">Residential Address line 1 </label> 
                            <p class="error" v-for="error in errors.collect('address1')">{{ error }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <input placeholder=" " class="form-control form-control" v-model="address2" name="address2"  type="text" :class="{ 'is-invalid': submitted && errors.has('address2') }" ref="address2Input" >
                            <label for="username" class="labeltext"> Residential Address line 2 </label> 
                        </div> 
                    </div>
                </div>  
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <input placeholder=" " class="form-control form-control"  v-model="post_code" name="post_code"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('post_code') }" ref="post_codeInput" >
                            <label for="username" class="labeltext"> Post Code</label> 
                            <p class="error" v-for="error in errors.collect('post_code')">The post code is required</p> 
                        </div> 
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <select name="residence_country" v-validate="'required'" v-model="residence_country" :class="(residence_country != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('residence_country') })" ref="residence_countryInput" class="form-control form-control">
                                <option v-for="list in $env_var.countriesList" :value="list.code">{{list.name}}</option>
                            </select>
                            <label for="username" class="labeltext"> Country of Residence</label> 
                            <p class="error" v-for="error in errors.collect('residence_country')">The residence country is required</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <select name="nationality" v-validate="'required'" v-model="nationality_country" :class="(nationality_country != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('nationality') })" ref="nationalityInput" class="form-control form-control">
                                <option v-for="list in $env_var.countriesList" :value="list.code">{{list.name}}</option>
                            </select>
                            <label for="username" class="labeltext"> Country of Nationality</label> 
                            <p class="error" v-for="error in errors.collect('nationality')">The nationality country is required</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group field-wrapper" > 
                            <input placeholder=" " class="form-control form-control" name="city" v-model="city" type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('city') }" ref="cityInput" >
                            <label for="username" class="labeltext"> City or Town</label> 
                            <p class="error" v-for="error in errors.collect('city')">{{ error }}</p> 
                        </div> 
                    </div>
                     <div class="col-12 col-md-6">
                        <div class="field-wrapper">  
                            <div class="supportingdocument w-100">
                                <p class="btn mb-1" @click="$refs.address.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>Upload recent address proof</p>
                                <input type="file"  name="document[]" value="Upload Document" ref="address" v-on:change="onFileChange($event.target.files)" v-validate="'required'" class="form-control form-control" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
                                <p class="error" v-for="error in errors.collect('document[]')">document is required</p>
                            </div>
                            <div class="linerUpload d-flex align-items-center mb-3" v-if="document != ''">
                            <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document}}  </span>
                            <a href="#" class="closeBtn" @click="clearDoc('address')"><feather type="x"></feather></a>
                            </div>
                        </div>   
                    </div>
                </div>
                <div class="text-center">
                    <button class="cap_btn large_btn blue" :class="(pageLoader)?'disabled':''"> Change Address</button> 
                </div>
            </div>
        </form>
        <div class="mt-2 middleBox" v-if="trans_id != '' && !congModule"> 
            <app-OptVerfication :transaction_id="trans_id" :module="'1'" :title_parent="'90'" :data="''" :ticketRequestFrom="'profileOtp'" :accountId="''"></app-OptVerfication>
        </div>
        <div class="mt-2 middleBox" v-if="congModule">
            <div class="resultInfo text-center">
             <img src="../../../../static/website/images/success-icon.svg" alt="Icon">
            <p>your ticket for Change address is placed</p>
            <button class="cap_btn blue" @click="$parent.editAddress = false">back</button>
            </div>
        </div>
    </diV>
</template>
<script>
import { supportMixins } from '@/plugins/support'
import optVerfication from '../supports/services/otp_verification'
export default {
    name: 'Edit-Address',
    mixins: [supportMixins],
    data() {
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            submitted: false,
            address1: '',
            address2: '',
            post_code: '',
            residence_country: '',
            nationality_country: '',
            city: '',
            trans_id : '',
            document : '',
            congModule : false
        }
    },
    components: {
        appOptVerfication : optVerfication,
    },
    methods:{
        backTick(){
          this.trans_id = ''  
          this.document = ''  
          this.residence_country = ''  
        },
        onFileChange(file) {
            this.document = file[0].name
        },
        clearDoc(getdocType){
            this.document = ''
            this.$refs.address.value = ''
        },
        submitNow(){
            if(this.pageLoader){return;}
            const _that = this
            _that.submitted = true;

            let addressForm = document.getElementById('addressForm');
            let comment = 'Please Change my Address as per following details <br> Address1 : '+ addressForm.elements[0].value + '<br> Address2 : ' +  addressForm.elements[1].value + '<br> Post Code : ' + addressForm.elements[2].value +'<br> Residence Country : '+ addressForm.elements[3].value + '<br> Nationality : '+ addressForm.elements[4].value +'<br> City :'+ addressForm.elements[5].value
            let form_name = new FormData(addressForm);
            form_name.append("reason", '1');
            form_name.append("reason_text", 'Profile');
            form_name.append("title", '90');
            form_name.append("title_text", 'Change Address');
            form_name.append("text", comment);
            _that.$validator.validate().then(valid => {
                if (valid){
                    let input_json={
                        'globalParams' :{
                            'form' : form_name
                        },
                        'localParams' :{ "parameter" : _that , 'type' :'form' }
                    }
                    _that._runTicketRequestOtp(input_json)
                }    
            })
        }
    },
    created(){
        this.address1 = (this.profileInfo.address1)?this.profileInfo.address1:''
        this.address2 = (this.profileInfo.address2)?this.profileInfo.address2:''
        this.post_code = (this.profileInfo.post_code)?profileInfo.post_code:''
        this.residence_country = (this.profileInfo.residence_country)?(this.$env_var.countriesList[this.profileInfo.residence_country]?this.profileInfo.residence_country:''):''
        this.nationality_country = (this.profileInfo.nationality)?(this.$env_var.countriesList[this.profileInfo.nationality]?this.profileInfo.nationality:''):''
        this.city = (this.profileInfo.city)?this.profileInfo.city:''
    }
}

</script>


// WEBPACK FOOTER //
// src/components/website/account/edit_Address.vue